var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHostinger = function SvgHostinger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2623_4651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.00024L8.48259 4.41397V8.89668H15.0342L19.172 11.3104H4V2.00024ZM20.896 10.6208V4.41397L16.0685 2.00024V7.86219L20.896 10.6208ZM20.896 21.9998L16.4134 19.5861V15.1034H9.86184L5.724 12.6897H20.896V21.9998ZM4 13.3793V19.5861L8.82735 21.9998V16.1379L4 13.3793Z",
    fill: "#6747C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2623_4651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.896,
    height: 20,
    fill: "white",
    transform: "translate(4 2)"
  })))));
};

export { SvgHostinger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjYyM180NjUxKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNCAyLjAwMDI0TDguNDgyNTkgNC40MTM5N1Y4Ljg5NjY4SDE1LjAzNDJMMTkuMTcyIDExLjMxMDRINFYyLjAwMDI0Wk0yMC44OTYgMTAuNjIwOFY0LjQxMzk3TDE2LjA2ODUgMi4wMDAyNFY3Ljg2MjE5TDIwLjg5NiAxMC42MjA4Wk0yMC44OTYgMjEuOTk5OEwxNi40MTM0IDE5LjU4NjFWMTUuMTAzNEg5Ljg2MTg0TDUuNzI0IDEyLjY4OTdIMjAuODk2VjIxLjk5OThaTTQgMTMuMzc5M1YxOS41ODYxTDguODI3MzUgMjEuOTk5OFYxNi4xMzc5TDQgMTMuMzc5M1oiIGZpbGw9IiM2NzQ3QzciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNjIzXzQ2NTEiPgo8cmVjdCB3aWR0aD0iMTYuODk2IiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";